/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// react-router-dom components
import {Link} from "react-router-dom";

// @mui material components

// Material Dashboard 2 PRO React components

// Images
import React, {useState} from "react";
import {Alert, Box, Button, Paper, TextField, Typography} from "@mui/material";
import bgImage from "../splash.jpg";
import SplashScreen from "../Layout/SplashScreen";

export default function ResetPage() {
    const [username, setUsername] = useState("");
    const [flash, setFlash] = useState("");
    const registerUser = (e) => {
        e.preventDefault();
        const sentData = {username: username};

        fetch("/api/user/reset", {
            cache: "no-cache",
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(sentData),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                response.json().then(function (data) {
                    setFlash(<Alert severity="success">Wysłano email pozwalający na zmianę hasła.</Alert>);
                });
            })
            .catch((error) => {
                console.log(error.message);
            });
    };


    return (
        <SplashScreen background={bgImage} title={'Wakacyjne Zajęcia'}>
            <Paper elevation={24} sx={{
                width: '500px',
                maxWidth: '80vw',
                overflow: 'visible',
                overflowWrap: 'break-word',
                backgroundClip: 'border-box',
                paddingTop: '1px'
            }}>
                <Box
                    mx={2}
                    mt={-3}
                    p={2}
                    mb={1}
                    textAlign="center"
                    sx={{
                        background: 'linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))',
                        boxShadow: 'rgba(0, 0, 0, 0.14) 0rem 0.25rem 1.25rem 0rem, rgba(64, 64, 64, 0.4) 0rem 0.4375rem 0.625rem -0.3125rem',
                        margin: '-24px 16px 8px',
                        padding: '16px',
                        borderRadius: '0.375rem',
                        opacity: 1
                    }}
                >
                    <Typography variant="h5" fontWeight="light" color="white">
                        Zapomniałeś hasła?
                    </Typography>
                </Box>
                {flash}
                <Box pt={4} pb={3} px={3}>
                    <Box component="form" role="form" onSubmit={registerUser}>
                        <Box mb={2}>
                            <TextField autoFocus type="email" label="Email" variant="standard" fullWidth autoComplete={'email'}
                                       value={username} onChange={(e) => setUsername(e.target.value)}/>
                        </Box>
                        <Box mt={4} mb={1}>
                            <Button variant="contained" color="primary" fullWidth type={'submit'}>
                                Zresetuj hasło
                            </Button>
                        </Box>
                        <Box mt={3} mb={1} textAlign="center">
                            <Typography variant="button" color="text">
                                Już pamiętasz?{" "}
                                <Typography
                                    component={Link}
                                    to="/login"
                                    variant="button"
                                    color="info"
                                    fontWeight="medium"
                                    textGradient
                                >
                                    Zaloguj się
                                </Typography>
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </SplashScreen>);
}
